import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/components/common/theme-provider";
import TabsPage from "./pages/TabsPage";
import NotesPage from "./pages/NotesPage";
import NotFound from "./pages/NotFound";
import LoginPage from "./pages/LoginPage";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/route/ProtectedRoute";
import { PublicRoute } from "./components/route/PublicRoute";
import IndexPage from "./pages/IndexPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import { isChromeExtension } from "@/lib/utils";

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="system" storageKey="hintword-theme">
        <TooltipProvider>
          <AuthProvider>
            <div className="min-h-screen bg-background text-foreground">
              <Toaster />
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                {isChromeExtension() ?
                  <Route path="/" element={<Navigate to="/tabs" replace />} /> :
                  <Route path="/" element={<PublicRoute><IndexPage /></PublicRoute>} />
                }
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route
                  path="/tabs"
                  element={
                    <ProtectedRoute>
                      <TabsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/notes"
                  element={
                    <ProtectedRoute>
                      <NotesPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </AuthProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
